<template>
  <div class="lms-facilitator-grading-classroom-selection">
    <JwlError v-if="error" :jwl-error="error" />
    <div v-else-if="loadingState < 2">
      <JwlIcon loading-icon margin-right />
      {{t('common.loadingData')}}
    </div>
    <div class="lms-facilitator-grading-classroom-selection__buttons" v-else-if="facilitatorInterfaces.length > 0 && selectedFacilitatorInterface">
      <div class="button-wrap" :class="getClasses(classroom, index)"
           v-for="(classroom, index) in facilitatorInterfaces"
           :key="classroom.id">
        <JwlButton
          button-tab
          button-small
          @button-clicked="changeSelection(classroom)"
          :button-active="selectedFacilitatorInterface.id === classroom.id">
          {{ classroom.course.courseCode }}<br />
          {{ classroom.classroomIdentifer }}
          <span class="lms-facilitator-grading-classroom-selection__counter">
            {{classroom.countNotGraded}} / {{classroom.countGradeNotPublished}}
          </span>
        </JwlButton>
      </div>
    </div>
    <div v-else-if="selectedFacilitatorInterface === null">
      <FacilitatorGradingNotification icon-name="check-circle" icon-style="regular" :top-text="t('facilitatorGrading.notification.homeNoTasksOpenTop')" />
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    autoLoadFirst: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits(['selected']);

  const { t } = useI18n();

  const learningStore = useLearningStore();

  const facilitatorInterfaces = ref([]);
  const selectedFacilitatorInterface = ref(null);
  const loadingState = ref(0);
  const error = ref(null);

  const changeSelection = (selectedClassroom) => {
    if (selectedClassroom) {
      selectedFacilitatorInterface.value = selectedClassroom;
      emits('selected', selectedClassroom);
    }
  };

  const getFacilitatorInterfaces = () => {
    loadingState.value = 1;
    learningStore.getData('facilitator/facilitatorinterfaces')
      .then((data) => {
        facilitatorInterfaces.value = data;
        if (props.autoLoadFirst && facilitatorInterfaces.value.length > 0) {
          let first = null;
          facilitatorInterfaces.value.forEach((faI) => {
            if (first === null && (faI.countGradeNotPublished > 0 || faI.countNotGraded > 0)) {
              first = faI;
            }
          });
          changeSelection(first);
        }
        loadingState.value = 2;
      })
      .catch((e) => {
        error.value = e;
        loadingState.value = -1;
      });
  };

  const getClasses = (classroom, index) => `index-${index} countNotGraded-${classroom.countNotGraded} countGradeNotPublished-${classroom.countGradeNotPublished}`;

  getFacilitatorInterfaces();
</script>

<style lang="scss">
@use '@base/styles/mixins';
@use '@base/styles/variables';

.lms-facilitator-grading-classroom-selection {
  &__buttons {
    align-items: stretch;
    display: grid;
    grid-auto-columns: auto;
    grid-auto-flow: row;
    grid-auto-rows: auto;
    grid-gap: .25rem;
    grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));
    justify-content: stretch;
    width: 100%;
  }

  &__counter {
    background-color: var(--color-blue);
    color: var(--color-white);
    font-size: .75rem;
    padding: .2rem .5rem;
    position: absolute;
    top: -.75em;
    right: -.15em;
    border-radius: .5rem;
  }
  .button-wrap.countNotGraded-0.countGradeNotPublished-0{
    display: none;
  }
}
</style>
